<script setup>
import {reactive, onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  loading: false,
  generatingReport: false,
  dates: [],
  dataLoading: true,
  search: null,
  newRule: false,
  newClientId: null,
  newPerson: null,
  newPercent: null,
  newId: null,
  headers: [
    { title: 'Name', key: 'name' },
    { title: 'Client', key: 'company' },
    { title: 'Percent', key: 'percent' },
    { title: 'Actions', key: 'actions' },
  ],
  items: [],
  clients: [],
});

const downloadCSV = () => {
  if(data.dates.length < 2){
    ToastUtil.errorMsg('Please select a date range')
  }
  else{
    if(data.dates.length > 2){
      let minDate=new Date(Math.min.apply(null,data.dates));
      let maxDate=new Date(Math.max.apply(null,data.dates));
      data.dates=[minDate,maxDate];
  }
    data.loading = true
    ApiWrapper.post('marketing', 'get-my-pay', {
          dates: data.dates
        })
        .then((response) => {
          let csvContent = 'data:text/csv;charset=utf-8,'
          csvContent += response.csvData
          const csvData = encodeURI(csvContent)
          const link = document.createElement('a')
          link.setAttribute('href', csvData)
          link.setAttribute('download', 'MarketingPay_' + data.dates[0] + '~' + data.dates[1] +'.csv')
          link.click()
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.loading = false
        });
  }
}

const getData = () => {
  ApiWrapper.post('marketing', 'get-my-rules', {})
      .then((response) => {
        if(response.items){
          data.items = response.items
        }
        if(response.clients){
          data.clients = response.clients
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
        data.loading = false
      });
}


onMounted(()=>{
  getData()
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>My Marketing Rules</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-text-field
            v-model="data.search"
            append-inner-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            class="px-10"
        ></v-text-field>

        <v-spacer></v-spacer>
        <div class="mx-2">
          <v-btn variant="elevated" size="small" color="primary" @click="data.generatingReport=true">
            Generate My Marketing Pay Report
          </v-btn>
        </div>

      </v-toolbar>
      <v-row v-if="data.generatingReport">
        <v-col cols="12" sm="6">
          <v-layout justify-center>
            <v-date-picker
                v-model="data.dates"
                multiple="range"
            ></v-date-picker>
          </v-layout>
        </v-col>

        <v-col cols="12" sm="6">
          <v-btn
              size="small"
              variant="elevated"
              class="px-2"
              @click="data.generatingReport=false; downloadCSV()"
              color="primary"
          >
            Download
          </v-btn>
          <v-btn
              size="small"
              variant="elevated"
              class="px-2"
              @click="data.generatingReport=false;"
              color="error"
          >
            Cancel
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.personname`]="{ item }">
          <RouterLink :to="`/userprofile/${item.personid}`">
            {{ item.personname }}
          </RouterLink>
        </template>
        <template v-slot:[`item.clientname`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`">
            {{ item.clientname }}
          </RouterLink>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>